// GET

import axios from 'axios';
import { ReportTemplate } from 'views/fish-check/features/welfare-scoring/types/report-template.type';

// /ewosapi/v1/FieldRegistration/company/{globalCompanyId}/welfare/report/template/{language}
export const getReportTemplates = async (globalCompanyId: string, language?: string): Promise<ReportTemplate[]> => {
  let url = `/ewosapi/v1/fieldregistration/company/${globalCompanyId}/welfare/report/template/`;

  if (language) url += language;

  const res = await axios.get<ReportTemplate[]>(url);
  return res.data;
};
